
import React from 'react';
import TradeAreaAnalyzerView from '../components/trade_area_analyzer/TradeAreaAnalyzerView';
import PageHeader from '../components/common/PageHeader';

const TradeAreaAnalyzer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        pageTitle="Trade Area" 
        mainTitle="Trade Area Analyzer"
        description="Analyze station performance in geographic context"
        showBackButton={true}
      />
      <div className="p-6">
        <TradeAreaAnalyzerView />
      </div>
    </div>
  );
};

export default TradeAreaAnalyzer;
